const state={
  activeTab:'reserve'
}

const getters={
  activeTab: state => state.activeTab
}

const actions={
  active_tab({commit}, key){
    commit('BOTTOM_TAB_BAR',key)
  }
}

const mutations={
  BOTTOM_TAB_BAR(state, key){
    state.activeTab = key;
  }
}


export default{
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/tabbar/tabbar.js